import { Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../Model/utility/utility.service';
import { Config } from 'ng-otp-input/lib/models/config';
import { SessionService } from '../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgOtpInputComponent, NgOtpInputModule } from 'ng-otp-input';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';

@Component({
  selector: 'app-mpindialog',
  standalone: true,
  imports: [FormsModule, CommonModule, NgOtpInputModule],
  templateUrl: './mpindialog.component.html',
  styleUrl: './mpindialog.component.scss'
})
export class MPINDialogComponent {
  isDisabled: boolean = false;
  user = [] as any;
  showMPIN = false;

  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput!: NgOtpInputComponent;
  
  data = {
    SelectType: 'U',
    EmpMasterId: null,
    OneTime_LocalAuthOption: false,
    IsFingerPrintEnabled: false,
    IsMPINEnabled: false,
    MPIN: null as any
  };
  constructor(
    private activeModal: NgbActiveModal,
    private utility: UtilityService,
    private session: SessionService,
    private toast: ToastService
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.Mobile_ESS_Get_LocalAuthDetails();
  }

  Mobile_ESS_Get_LocalAuthDetails() {
    this.isDisabled = true;
    this.utility.Mobile_ESS_Get_LocalAuthDetails({ 'SelectType': 'S', 'EmpMasterId': this.user.UserId }).subscribe({
      next: (response) => {
        response = JSON.parse(response);
        if (response && response.Table.length > 0) {
          this.data.EmpMasterId = this.user.UserId;
          this.data.OneTime_LocalAuthOption = response.Table[0].OneTime_LocalAuthOption;
          this.data.IsFingerPrintEnabled = response.Table[0].IsFingerPrintEnabled;
          this.data.IsMPINEnabled = response.Table[0].IsMPINEnabled;
          this.data.MPIN = response.Table[0].MPIN;
          if(this.data.MPIN != null){
            this.ngOtpInput.setValue(this.data.MPIN);
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }

  Mobile_ESS_Update_LocalAuthUpdate() {
    if (this.data.MPIN != null && this.data.MPIN != '' && this.data.MPIN.length == 4) {
      this.isDisabled = true;
      this.utility.Mobile_ESS_Update_LocalAuthUpdate(this.data).subscribe({
        next: (response) => {
          response = JSON.parse(response);
          if(response.ErrorCode == '446'){
            this.close(true);
            this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.success });
          }else{
            this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.danger });
          }
          
          this.isDisabled = false;
        },
        complete: () => {
          return true
        },
        error: (err) => {
          this.isDisabled = false;
          return false;
        }
      })
    } else {
      this.toast.show({ message: "Plase enter 4 digit MPIN", type: toastTypeEnum.danger });
    }
  }

  close(result: boolean) {
    this.activeModal.close(result);
  }

  toggleMPINVisibility(Flag: number) {
    if (Flag == 1) {
      this.showMPIN = !this.showMPIN;
    }
  }

  onMpinChange(event: any) {
    this.data.MPIN = event;
  }

  onSwitchChange(event: any) {
    this.data.IsMPINEnabled = event.target.checked;
  }
}
